import * as React from 'react'

import theme from 'theme'
import AttackArgIcon from 'components/common/AttackArgIcon'
import Popover from 'components/common/Popover'
import CardTooltip from 'components/common/CardTooltip'
import Text from 'components/common/Text'

type ArgIconProps = {
  className?: string
  icon: string
  attack?: string
  tooltip: React.ReactNode
}

const ArgIcon: React.FC<ArgIconProps> = ({
  className,
  tooltip,
  icon,
  attack
}) => {
  return (
    <div className={className}>
      <Popover>
        {({ getTargetProps, getPopoverProps }) => (
          <div
            css={{
              height: theme.space[5],
              width: theme.space[5],
              flex: `0 0 ${theme.space[5]}px`
            }}
          >
            <div
              title={tooltip || 'Argument Icon'}
              {...getTargetProps({
                css: {
                  borderColor: theme.colors.gray[1],
                  backgroundColor: 'white',
                  borderStyle: 'solid',
                  borderWidth: 1,
                  borderRadius: '100%',
                  height: '100%',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex'
                }
              })}
            >
              <AttackArgIcon
                attack={attack}
                css={{ color: theme.colors.steel[1] }}
                icon={icon}
              />
            </div>
            <CardTooltip
              displayArrow
              size="small"
              variation="dark"
              {...getPopoverProps({
                css: {
                  maxWidth: 250,
                  wordBreak: 'break-word'
                }
              })}
            >
              <Text as="small" color="white">
                {tooltip}
              </Text>
            </CardTooltip>
          </div>
        )}
      </Popover>
    </div>
  )
}

export default ArgIcon
